import deepEqual from "fast-deep-equal";
import debounce from "lodash/debounce";
import { temporal } from "zundo";
import { createStore } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";
import { createBlockManagementSlice } from "./blockManagementSlice";
import { createBlockRegistrySlice } from "./blockRegistrySlice";
import { createDragAndDropSlice } from "./dragAndDropSlice";
import { createInterfaceSlice } from "./interfaceSlice";
import { createPagesSlice } from "./pagesSlice";
import type { BuilderUIState, InitialData } from "./types";

export type Middlewares = [
  ["zustand/devtools", never],
  ["zustand/subscribeWithSelector", never],
];

export type Mutators = [];

export const createBuilderUIStore = (initialData: InitialData) =>
  createStore<BuilderUIState>()(
    // You need to install Redux DevTools extension to see the actions in the Redux DevTools panel
    // https://zustand.docs.pmnd.rs/middlewares/devtools
    // https://chromewebstore.google.com/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd
    devtools(
      subscribeWithSelector(
        temporal(
          (...args) => ({
            ...createInterfaceSlice(initialData)(...args),
            ...createBlockManagementSlice(...args),
            ...createBlockRegistrySlice(...args),
            ...createDragAndDropSlice(...args),
            ...createPagesSlice(initialData)(...args),
            ...initialData,
          }),
          {
            partialize: state => ({ pages: state.pages }),
            handleSet: handleSet => debounce(handleSet, 500),
            equality: deepEqual,
          },
        ),
      ),
      { trace: true },
    ),
  );

export type BuilderUIStore = ReturnType<typeof createBuilderUIStore>;
